export default __webpack_public_path__ + "static/media/service5.16da873f.jpeg";